import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem, OperationSearchItem } from '@interfaces/search';
import { SingleJobOrList } from '@v2/pages/machines/modules/now/components/Job/components/SingleJobOrList';

interface NCFileDetailsJobsProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
  jobs: ReducerEntityWithLoadingState<OperationSearchItem[]>;
  jobId: number | null;
}

const NCFileDetailsJobsComponent: FC<NCFileDetailsJobsProps> = ({
  getNCFileById,
  getProductionBatchByNCFile,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  jobs,
  jobId,
  getNCFileByName,
}) => {
  const title = useTitle();

  const { jobDataLoading } = useNCFileDetails({
    getNCFileById,
    getProductionBatchByNCFile,
    getTools,
    clearTools,
    updateHeaderConfig,
    operationsSearch,
    loadAllJobs: true,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.job}>
        <SingleJobOrList jobs={jobs.data} jobId={jobId} loading={!jobs.wasLoaded} jobDataLoadingForList={jobDataLoading} />
    </DetailsPageWrapper>
  );
};

const NCFileDetailsJobs = connect(({ details: { jobs, jobId } }) => ({ jobs, jobId }), {
  getNCFileById,
  getProductionBatchByNCFile,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsJobsComponent);

export { NCFileDetailsJobs };
